var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"MvsAfv3iCAgny5BvIoNYg"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/postsales";

import * as Sentry from '@sentry/nextjs'

const BLACKLISTED_EXCEPTION_TYPE = ['NotOkError @c3po 401 Unauthorized', 'LegacyError @narf result 2', '401 Unauthorized']
const blacklistedExceptionType = (event) => BLACKLISTED_EXCEPTION_TYPE.includes(event.exception.values[0].type)

const beforeSend = (event) => {
  try {
    if (blacklistedExceptionType(event)) return null
    return event
  } catch {
    return event
  }
}

Sentry.init({
  dsn: process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.CUSTOM_ENV,
  release: process.env.CI_COMMIT_SHORT_SHA,
  tracesSampleRate: 0.2,
  attachStacktrace: true,
  maxBreadcrumbs: 50,
  ignoreErrors: [
    'Network request failed',
    'Failed to fetch',
    'Network Error',
    'NetworkError',
    'Request aborted',
    "undefined is not an object (evaluating 'window.actions.webviewNavigationDone')",
    'top.GLOBALS',
    'originalCreateNotification',
    'canvas.contentDocument',
    'fb_xd_fragment',
    'ResizeObserver loop limit exceeded',
    'can\'t redefine non-configurable property "userAgent"',
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    /connect\.facebook\.net\/fr_FR\/all\.js/i,
    // OneTrust
    /scripttemplates\//i,
    // Chrome extensions
    /extensions\//i,
    /extension\//i,
    /^chrome:\/\//i,
  ],
  beforeSend,
})
